import { z } from "zod";

export const rawNumberSchema = z.object({ raw: z.coerce.number() });
